<template>
  <div id="component-loading" :class="{ overlay: !fullPage }">
    <div class="loading-card">
      <div class="loading-badge"></div>
      <div class="loading-spinner"></div>
      <h2 class="loading-title">{{ title }}</h2>
      <p class="loading-subtitle">{{ subtitle }}</p>
      <p class="loading-message">{{ currentMessage }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Loading',
  props: {
    title: {
      type: String,
      default: 'Carregando...'
    },
    subtitle: {
      type: String,
      default: 'Aguarde enquanto concluímos esta etapa.'
    },
    messages: {
      type: Array,
      default: () => ([
        'Estamos preparando tudo para você...',
        'Isso leva só alguns segundos.'
      ])
    },
    rotateMessages: {
      type: Boolean,
      default: true
    },
    fullPage: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentMessage: '',
      intervalId: null,
      messageIndex: 0,
    }
  },
  mounted() {
    this.currentMessage = this.messages[0] || '';

    if (this.rotateMessages && this.messages.length > 1) {
      this.intervalId = setInterval(() => {
        this.messageIndex = (this.messageIndex + 1) % this.messages.length;
        this.currentMessage = this.messages[this.messageIndex];
      }, 5000);
    }
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
}
</script>

<style lang="scss">
#component-loading {
  position: fixed;
  inset: 0;
  background: linear-gradient(180deg, #fff8f5 0%, #ffffff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  z-index: 9999;

  &.overlay {
    background: rgba(255, 255, 255, 0.88);
  }
}

.loading-card {
  width: min(100%, 420px);
  background: #ffffff;
  border: 1px solid #f4d6cb;
  border-radius: 20px;
  padding: 36px 28px;
  box-shadow: 0 20px 45px rgba(109, 54, 29, 0.12);
  text-align: center;
}

.loading-badge {
  width: 54px;
  height: 8px;
  border-radius: 999px;
  background: linear-gradient(90deg, #fa4616 0%, #ffb19b 100%);
  margin: 0 auto 22px;
}

.loading-spinner {
  width: 78px;
  height: 78px;
  margin: 0 auto 24px;
  border: 6px solid #fde4db;
  border-top-color: #fa4616;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.loading-title {
  margin: 0;
  color: #2f1a12;
  font-size: 1.35rem;
  font-weight: 700;
}

.loading-subtitle {
  margin: 10px 0 0;
  color: #7a5a4e;
  font-size: 0.98rem;
  line-height: 1.5;
}

.loading-message {
  margin: 18px 0 0;
  color: #a05a41;
  font-size: 0.92rem;
  min-height: 1.4em;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
